import api from "../axiosIntercepture";

/* ================================
   CREATE GEOGRAPHY
================================ */
export const createGeography = async (payload) => {
    try {
        const response = await api.post("geography/create", payload);

        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }

        throw new Error(response.data?.message || "Failed to create Geography");
    } catch (err) {
        console.error("Error creating Geography:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to create Geography"
        );
    }
};


/* ================================
   FETCH GEOGRAPHY (List + Single)
================================ */
export const fetchGeography = async (page = 0, pageSize = 10) => {
    try {
        const sendObj = {
            page: page + 1,
            limit: pageSize
        };

        const response = await api.post("geography/fetch-multi-dynamic", sendObj);

        if (!response.data?.success) {
            throw new Error(response.data?.message || "Failed to fetch Geography");
        }

        return response.data.data;

    } catch (err) {
        console.error("Error fetching Geography:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to fetch Geography"
        );
    }
};


/* ================================
   FETCH GEOGRAPHY BY ID
================================ */
export const fetchGeographyById = async (id) => {
    try {
        const response = await api.post("geography/fetch", { id });

        if (response.data?.success) {
            return response.data.data;
        }

        throw new Error(response.data?.message || "Failed to fetch Geography");
    } catch (err) {
        console.error("Error fetching Geography by ID:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to fetch Geography"
        );
    }
};


/* ================================
   UPDATE GEOGRAPHY
================================ */
export const updateGeography = async (geoId, payload) => {
    if (!geoId) throw new Error("Missing identifier for update");

    try {
        const encoded = encodeURIComponent(geoId);
        const response = await api.post(
            `geography/update/${encoded}`,
            payload
        );

        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }

        throw new Error(response.data?.message || "Failed to update Geography");

    } catch (err) {
        console.error("Error updating Geography:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to update Geography"
        );
    }
};


/* ================================
   GET NEXT GEO ID
================================ */
export const getNextGeoId = async () => {
    try {
        const response = await api.post("geography/next-id");

        if (response.data?.success && response.data?.data) {
            return response.data.data.geoId;
        }

        throw new Error(response.data?.message || "Failed to fetch Geo ID");

    } catch (err) {
        console.error("Error fetching Geo ID:", err);
        throw new Error(
            err?.response?.data?.message || "Failed to fetch Geo ID"
        );
    }
};
